"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function ht(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M13.8496 8.43716C13.8496 5.79716 12.5693 3.55766 11.6093 2.83766C11.6093 2.83766 11.5291 2.75741 11.5291 2.91716C11.4496 7.95716 8.88906 9.31766 7.52931 11.2377C4.24956 15.4774 7.28931 20.1972 10.4093 21.0777C12.1696 21.5577 10.0096 20.1972 9.76956 17.3974C9.36906 13.8777 13.8496 11.3172 13.8496 8.43716Z", fill: color }),
        React.createElement("path", { d: "M15.5296 10.1974C15.3691 10.8372 14.7293 12.1977 13.8496 13.4772C10.8893 17.7177 12.5693 19.7974 13.5293 20.9172C14.0896 21.5577 13.5293 20.9172 14.8891 20.2774C14.9693 20.1972 17.6093 18.8374 17.8493 15.7174C18.1696 12.6777 16.2496 10.7577 15.5296 10.1974Z", fill: color }));
}
exports["default"] = ht;
//# sourceMappingURL=ht.js.map